import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Body } from '../../../../components/HotelDetailsOverlay/components/DescriptionSection/components/Body.js';
import { HotelCard } from '../../../../components/HotelDetailsOverlay/components/DescriptionSection/components/HotelCard/index.js';
import { TextBlock } from '../../../../components/HotelDetailsOverlay/components/DescriptionSection/components/TextBlock/index.js';
import { useConfig } from '../../../../components/HotelDetailsOverlay/context/Config.js';
import { Alert, HeadlineLarge, HeadlineMedium, HeadlineSmall, HelpTooltip, ParagraphMedium, Stack } from '../../../../primitives/index.js';
export const DescriptionSection = ({
  data: {
    hotelName,
    hotelAddress,
    hotelCategory,
    hotelCategoryType,
    hotelImage,
    curatedDescription,
    tourOperatorName,
    tourOperatorImage,
    tourOperatorDescription,
    isSustainable,
    sustainableCertifier
  }
}) => {
  const {
    t
  } = useTranslation();
  const {
    description: {
      preferTourOperatorDescription
    }
  } = useConfig();
  const hasTourOperatorDescription = Boolean(tourOperatorDescription);
  const hasCuratedDescription = curatedDescription?.length > 0;
  return _jsxs(Stack, {
    children: [_jsx(HeadlineLarge, {
      children: t('hotelDetailsOverlay:descriptionSection.headline')
    }), _jsx(HotelCard, {
      name: hotelName,
      address: hotelAddress,
      category: hotelCategory,
      categoryType: hotelCategoryType,
      image: hotelImage,
      isSustainable: isSustainable,
      sustainableCertifier: sustainableCertifier
    }), preferTourOperatorDescription && hasTourOperatorDescription ? _jsx(Body, {
      children: _jsxs(Stack, {
        children: [_jsxs(Stack, {
          spacing: "small",
          children: [_jsx(HeadlineSmall, {
            children: t('hotelDetailsOverlay:descriptionSection.tourOperatorDescription.title')
          }), _jsxs(Stack, {
            direction: "row",
            children: [_jsx(ParagraphMedium, {
              children: tourOperatorName
            }), tourOperatorImage && _jsx("img", {
              src: tourOperatorImage,
              alt: tourOperatorName
            }), _jsx(HelpTooltip, {
              content: t('hotelDetailsOverlay:descriptionSection.tourOperatorDescription.tooltip')
            })]
          })]
        }), _jsx(TextBlock, {
          children: tourOperatorDescription
        })]
      })
    }) : hasCuratedDescription ? _jsx(Body, {
      children: _jsxs(Stack, {
        children: [preferTourOperatorDescription && !hasTourOperatorDescription && _jsx(Alert, {
          children: t('hotelDetailsOverlay:descriptionSection.missingTourOperatorDescription')
        }), _jsx(TextBlock, {
          title: _jsxs(HeadlineMedium, {
            children: [t('hotelDetailsOverlay:descriptionSection.curatedDescription.title') + ' ', _jsx(HelpTooltip, {
              content: t('hotelDetailsOverlay:descriptionSection.curatedDescription.tooltip')
            })]
          }),
          children: curatedDescription[0].content
        }), curatedDescription.slice(1).map(({
          title,
          content
        }, i) => _jsx(TextBlock, {
          title: _jsx(HeadlineSmall, {
            children: title
          }),
          children: content
        }, i))]
      })
    }) : _jsx(Alert, {
      children: t('hotelDetailsOverlay:descriptionSection.missingAnyDescription')
    })]
  });
};